import React, { PureComponent } from 'react'
import { Platform, View, TextInput, ScrollView } from 'react-native'
import styled from 'styled-components/native'
import KeyboardSpacer from 'react-native-keyboard-spacer'

import { Text } from '../../Atoms/Typography'
import Icon from '../../Atoms/Icon'
import Button from '../../Atoms/Button'
import PageHeader from '../../Molecules/PageHeader'
import Rating from '../../Molecules/Rating'
import InlineError from '../../Atoms/InlineError'

import theme from '../../../styles/theme'

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
  background: ${theme.colours.white};
`
const ScrollContainer = styled(ScrollView)``

const QuestionContainer = styled(View)`
  flex-direction: row;
  flex-grow: 1;
  padding: ${2 * theme.gutterUnit}px ${theme.gutterUnit}px;
  border-bottom-color: ${theme.colours.bordergrey};
  border-bottom-width: 1px;
`
const DetailsContainer = styled(View)`
  flex-direction: row;
  border-bottom-color: ${theme.colours.bordergrey};
  border-bottom-width: 1px;
`
const DetailQuestionContainer = styled(View)`
  width: 50%;
  padding: ${2 * theme.gutterUnit}px ${theme.gutterUnit}px;
  justify-content: flex-end;
`
const QuestionContent = styled(View)`
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  min-height: 180px;
  padding-left: ${2 * theme.gutterUnit}px;
`
const DetailQuestionLabel = styled(View)`
  padding-bottom: ${theme.gutterUnit}px;
`

const TextQuestion = styled(TextInput)`
  height: 200px;
  width: 100%;
  border-color: ${theme.colours.black};
  border-width: 1px;
  margin: ${theme.gutterUnit}px 0;
  padding: ${theme.gutterUnit}px;
  justify-content: flex-start;
  align-items: flex-start;
`

const DetailQuestion = styled(TextInput)`
  width: 100%;
  border-color: ${theme.colours.black};
  border-width: 1px;
  margin: ${theme.gutterUnit}px 0;
  padding: ${theme.gutterUnit}px;
  justify-content: flex-start;
  align-items: flex-start;
`

const QuestionText = styled(View)`
  padding-bottom: ${theme.gutterUnit}px;
`

const Footer = styled(View)`
  padding: ${theme.gutterUnit}px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-top-color: ${theme.colours.bordergrey};
  border-top-width: 1px;
`

const Submitted = styled(View)`
  padding: ${2 * theme.gutterUnit}px ${theme.gutterUnit}px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-color: ${theme.colours.primary};
  border-width: 1px;
  background-color: ${theme.colours.green};
`

export default class Survey extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      error: null
    }
  }

  onSubmit (teamId, deviceId, details, questions) {
    return () => {
      if (questions.filter(q => Object.prototype.hasOwnProperty.call(q, 'response') && q.response !== undefined).length === questions.length) {
        this.setState({
          error: null
        })
        this.props.onSubmit(teamId, {
          deviceId,
          details,
          responses: questions.map(({ index, response }) => ({ index, response }))
        })
      } else {
        this.setState({
          error: {
            message: 'Please respond to all survey questions.'
          }
        })
      }
    }
  }

  render () {
    const { details, onDetailUpdate, questions, onQuestionUpdate, isSubmitting, teamId, submitError, deviceId, submitted } = this.props
    const textAlignVertical = Platform.select({ android: { textAlignVertical: 'top' }, default: {} })
    return (
      <Container>
        <PageHeader />
        {this.state.error && <InlineError message={this.state.error.message} />}
        {submitError && <InlineError message={submitError.message} />}
        {submitted && (
          <Submitted>
            <Text size='m' white bold>Your responses have been submitted. You may update your responses if necessary.</Text>
          </Submitted>
        )}
        <ScrollContainer>
          <DetailsContainer>
            <DetailQuestionContainer>
              <DetailQuestionLabel>
                <Text size='m'>Optional Details:</Text>
              </DetailQuestionLabel>
              <Text size='s'>Name:</Text>
              <DetailQuestion
                underlineColorAndroid='transparent'
                onChangeText={text => onDetailUpdate('name', text)}
                placeholderTextColor='grey'
                value={details.name}
                autoCorrect={false}
                returnKeyType='done'
                maxLength={250}
                {...textAlignVertical}
              />
            </DetailQuestionContainer>
            <DetailQuestionContainer>
              <Text size='s'>Email:</Text>
              <DetailQuestion
                underlineColorAndroid='transparent'
                onChangeText={text => onDetailUpdate('email', text)}
                placeholderTextColor='grey'
                value={details.email}
                autoCorrect={false}
                returnKeyType='done'
                maxLength={250}
                {...textAlignVertical}
              />
            </DetailQuestionContainer>
          </DetailsContainer>
          {questions.map((question, i) => (
            <QuestionContainer key={i}>
              <Text size='m'>{question.label}</Text>
              <QuestionContent>
                <QuestionText>
                  <Text size='m'>{question.question}</Text>
                </QuestionText>
                {question.type === 'TEXT' ? (
                  <TextQuestion
                    multiline
                    underlineColorAndroid='transparent'
                    onChangeText={text => onQuestionUpdate(question.index, text)}
                    numberOfLines={10}
                    placeholderTextColor='grey'
                    value={question.response}
                    autoCorrect={false}
                    returnKeyType='done'
                    maxLength={250}
                    {...textAlignVertical}
                  />
                ) : (
                  <Rating rating={question.response} onChangeRating={({ value }) => onQuestionUpdate(question.index, value)} />
                )}
              </QuestionContent>
            </QuestionContainer>
          ))}
        </ScrollContainer>
        <Footer>
          <Button rounded secondary noborder onPress={this.onSubmit(teamId, deviceId, details, questions)} inProgress={isSubmitting}>
            <Icon size='s' name='tick' colour={theme.colours.black} />
            <Text
              size='m'
              bold
              overrides={{
                marginLeft: theme.gutterUnit
              }}
            >
              SUBMIT
            </Text>
          </Button>
        </Footer>
        <KeyboardSpacer />
      </Container>
    )
  }
}
